import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  CHECK_CATEGORIES,
  UCFUploadWidget,
} from '@chegg-wt/core/components/UCFUploadWidget'
import { Modal } from '@chegg-ui/modal'
import ClientOnlyPortal from '@chegg-wt/core/components/ClientOnlyPortal'
import useExitIntent from '@chegg-wt/core/hooks/useExitIntent'
import { AppState } from '@chegg-wt/core/state/types'
import { isProSelector } from '@chegg-wt/core/state/user/selectors'

export const TEST_ID = 'upload-widget-modal'

export const CONTROL_HEADING_TEXT = 'Check your paper for plagiarism errors'
export const CONTROL_SUBHEADING_TEXT =
  'Make sure you didn’t forget a source or cite incorrectly.'

export const VARIANT_HEADING_TEXT = 'Get professional proofreading for your drafts'
export const VARIANT_SUBHEADING_TEXT =
  'Score feedback on your writing within 24 hours after submitting it.'

interface UploadWidgetModalProps {
  isProUser?: boolean
}

export const UCFUploadWidgetModal: React.FC<UploadWidgetModalProps> = ({
  isProUser = false,
}) => {
  const { exitTriggered } = useExitIntent()
  const [isOpen, setIsOpen] = useState(exitTriggered)

  useEffect(() => {
    if (exitTriggered) setIsOpen(true)
  }, [exitTriggered])

  const widgetProps = {
    checkCategory: CHECK_CATEGORIES.PLAGIARISM,
    headingText: CONTROL_HEADING_TEXT,
    subheadingText: CONTROL_SUBHEADING_TEXT,
  }

  const shouldShowModal = exitTriggered && !isProUser

  const closeModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  return shouldShowModal ? (
    <ClientOnlyPortal>
      <Modal
        id="--ucf-upload-widget-modal"
        aria-label={widgetProps.headingText}
        isOpen={isOpen}
        onClose={closeModal}
        data-test={TEST_ID}
        shouldCloseOnClickOutside={false}
      >
        <UCFUploadWidget {...widgetProps} />
      </Modal>
    </ClientOnlyPortal>
  ) : null
}

const mapStateToProps = (state: AppState) => ({
  isProUser: isProSelector(state),
})

export default connect(mapStateToProps, {})(UCFUploadWidgetModal)
